import React from 'react';
import { FormikProps } from 'formik';
import { PersonFieldsDisplay } from '../../../components/read-only/person-fields-display';
import { MailingAddressDisplay } from '../../../components/read-only/mailing-address-display';
import { PhonesDisplay } from '../../../components/read-only/phones-display';
import { EmailsDisplay } from '../../../components/read-only/emails-display';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { RelationshipsProps } from '../../../models/account-info-epi-props';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DomesticPartnerFormModel } from '../model/domestic-partner-form-models';
import { SearchPerson } from '../../../../arc/features/person-search/person-search-model';
import { MapSearchPersonToReivewRenderModel } from '../domestic-partner-helpers';


interface Props {
    labelSetting: LabelSettingProps;
    relationshipsProps: RelationshipsProps;
    formProps: FormikProps<DomesticPartnerFormModel>;
    selectedPerson: SearchPerson;
}
export function DomesticPartnerConfirmation(props: Props) {

    const { labelSetting, formProps, relationshipsProps, selectedPerson } = props;

    const renderValue = MapSearchPersonToReivewRenderModel(selectedPerson);

    return (
        <>
            <PersonFieldsDisplay
                labelSetting={labelSetting}
                values={renderValue}
                sectionText={relationshipsProps.domesticPartnerPageTitle}
                dobMasked
            />
            <MailingAddressDisplay
                labelSetting={labelSetting}
                values={renderValue}
            />

            <PhonesDisplay
                labelSetting={labelSetting}
                values={renderValue}
            />

            <EmailsDisplay
                labelSetting={labelSetting}
                values={renderValue}
            />

            <DividerSection removeDivider>
                <FormField
                    name='start_date'
                    label={relationshipsProps.relationshipStartDateLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                    autoWidth
                />
            </DividerSection>

        </>
    );
}